import { utcToZonedTime, formatInTimeZone } from "date-fns-tz";

export const utcToZonedDate = (
  timestring: string | Date | number,
  timeZone: string
) => {
  return utcToZonedTime(timestring, timeZone);
};

export const formattedTime = (
  date: string | Date,
  dateFormat: string,
  timeZone: string
) => {
  return formatInTimeZone(date, timeZone, dateFormat);
};

export const eventFormatedDate = (eventDate: string) => {
  var date = new Date(eventDate);

  var day = date.getDate();
  var month = date.getMonth() + 1;
  var year = date.getFullYear();

  var formattedDate =
    (day < 10 ? "0" : "") +
    day +
    "." +
    (month < 10 ? "0" : "") +
    month +
    "." +
    year;

  return formattedDate;
};

export const nowUtc = (timeZone: string) => {
  return utcToZonedDate(new Date().getTime(), timeZone);
};
